import { Controller } from "@hotwired/stimulus"

// Name-first attendee add (Larry 2026-08-21). Typing filters the project's
// people by name, company or email; picking one fills the hidden email
// field. A name nobody matches is still added exactly as typed — the email
// box just stays visible for them to fill in.
export default class extends Controller {
  static targets = ["name", "email", "list"]
  static values = { people: Array }

  connect() {
    this._active = -1
    this.hide()
  }

  search() {
    const q = this.nameTarget.value.trim().toLowerCase()
    if (q.length < 2) return this.hide()

    const hits = this.peopleValue
      .filter((p) => `${p.name} ${p.company || ""} ${p.email}`.toLowerCase().includes(q))
      .slice(0, 6)
    if (!hits.length) return this.hide()

    this.listTarget.innerHTML = hits.map((p, i) => `
      <button type="button" role="option" data-idx="${i}" data-action="click->attendee-picker#pick"
              class="w-full text-left px-3 py-1.5 text-[13px] hover:bg-gray-50 cursor-pointer">
        <span class="text-gray-800">${this._esc(p.name)}</span>
        <span class="text-gray-400">${this._esc(p.company ? ` · ${p.company}` : "")}</span>
        <span class="block text-gray-400">${this._esc(p.email)}</span>
      </button>`).join("")
    this._hits = hits
    this._active = -1
    this.listTarget.classList.remove("hidden")
  }

  pick(e) {
    const p = this._hits?.[Number(e.currentTarget.dataset.idx)]
    if (!p) return
    this.nameTarget.value = p.name
    if (this.hasEmailTarget) this.emailTarget.value = p.email
    this.hide()
  }

  // ↓/↑ walk the list, Enter takes the highlighted one, Esc closes. Enter
  // with nothing highlighted falls through and submits the form as typed.
  keydown(e) {
    if (e.key === "Escape") return this.hide()
    if (this.listTarget.classList.contains("hidden")) return
    const opts = Array.from(this.listTarget.querySelectorAll("button"))
    if (!opts.length) return

    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      e.preventDefault()
      this._active = (this._active + (e.key === "ArrowDown" ? 1 : -1) + opts.length) % opts.length
      opts.forEach((o, i) => o.classList.toggle("bg-gray-100", i === this._active))
    } else if (e.key === "Enter" && this._active >= 0) {
      e.preventDefault()
      opts[this._active].click()
    }
  }

  hide() { this.listTarget.classList.add("hidden") }

  _esc(s) {
    const d = document.createElement("div")
    d.textContent = s || ""
    return d.innerHTML
  }
}
